import { useCallback, ChangeEvent, useState } from "react";
import { Form, Field, FormikProps, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import { ReactComponent as UploadFileIcon } from "../../../../assets/images/uploadFile.svg";
import "./react-datepicker.css";
import styles from "../styles.module.scss";
import { AnalysisLstatLogsUploadFormInitValuesInterface } from "../../../interfaces/fe.interfaces";
import { BounceLoader } from "react-spinners";

export interface AnalysisLstatLogUploadFormProps extends FormikProps<AnalysisLstatLogsUploadFormInitValuesInterface> {
  handleSubmit: () => void,
  handleOnVersionChangeCallback?: () => void,
  handleOnUsernameChangeCallback?: () => void,
  handleOnDateTimeChangeCallback?: () => void,
  handleOnNotesChangeCallback?: () => void,
}

const AnalysisLstatLogUploadForm = ({
  isSubmitting,
  values,
  setFieldTouched,
  setFieldValue,
  handleChange,
  handleSubmit,
}: AnalysisLstatLogUploadFormProps) => {
  const [trialDate, setTrialDate] = useState<Date  | null>(new Date());

  const handleOnChangeTrialDate = useCallback((date: Date | null) => {
    setFieldValue("date_time", date?.toString());
    return setTrialDate(date);
  }, []);

  const handleOnLstatLogsFileChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setFieldTouched("lstat_logs_batch_file_name", true);
    setFieldValue("lstat_logs_batch_file_name", e.target.files?.[0]?.name?.split?.(".")[0]);
    setFieldTouched("lstat_logs_batch_file", true);
    setFieldValue("lstat_logs_batch_file", e.target.files?.[0]);
  }, [
    setFieldTouched,
    setFieldValue
  ]);

  if (isSubmitting) return (
    <div className={styles.wisaAnalysisLstatLogsUploadLoader}>
      <BounceLoader color="#007dba"/>
      <p>Parsing logs ...</p>
    </div>
  );

  return (
    <Form className={styles.wisaAnalysisLstatLogsUploadForm} onSubmit={handleSubmit}>
      <fieldset className={styles.wisaAnalysisLstatLogsUploadFormFieldset}>
        <div className={styles.wisaAnalysisLstatLogsUploadFormGridItem}>
          <label className={styles.wisaAnalysisLstatLogsUploadFormIconLabel} htmlFor="lstat_logs_batch_file">
            <input
              id="lstat_logs_batch_file"
              name="lstat_logs_batch_file"
              type="file"
              onChange={handleOnLstatLogsFileChange}
              hidden
            />
            <UploadFileIcon className={styles.wisaAnalysisLstatLogsUploadFormUploadIcon}/>
            <div className={styles.wisaAnalysisLstatLogsUploadFormUploadMessagesWrapper}>
              <p className={styles.wisaAnalysisLstatLogsUploadFormFileName}>
                {values.lstat_logs_batch_file?.name ? values.lstat_logs_batch_file?.name : "Choose LSTAT batch zip folder"}
              </p>
              <ErrorMessage className={styles.error} name="lstat_logs_batch_file" component="p" />
            </div>
          </label>
        </div>
        <div className={`${styles.wisaAnalysisLstatLogsUploadFormGridItem}, ${styles.wisaAnalysisLstatLogsUploadFormGridItemSpan1}`}>
          <DatePicker selected={trialDate} onChange={handleOnChangeTrialDate} />
          <ErrorMessage className={styles.error} name="date_time" component="p" />
        </div>
        <div className={`${styles.wisaAnalysisLstatLogsUploadFormGridItem}, ${styles.wisaAnalysisLstatLogsUploadFormGridItemSpan3}`}>
          <Field
            id="notes"
            name="notes"
            type="text"
            className={`${styles.wisaAnalysisLstatLogsUploadFormField} ${styles.wisaAnalysisLstatLogsUploadFormFieldNotes}`}
            onChange={handleChange}
            placeholder="Add notes"
            values={values.notes}
          />
          <ErrorMessage className={styles.error} name="notes" component="p" />
        </div>
        <button type="submit" className={styles.wisaAnalysisLstatLogsUploadFormGridItem}>
          Submit
        </button>
      </fieldset>
    </Form>
  );
};

export default AnalysisLstatLogUploadForm;